import React, { useContext } from "react";
import cartStyles from "./Cart.module.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { TbShoppingCartX } from "react-icons/tb";
import { Link, useLocation } from "react-router-dom";
import { CartContext } from "../../context/CartContext";
import { EmptyCartContext } from "../../context/EmptyCartContext";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const Cart = ({ emptyCart }) => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  let currentPath = "";
  const crumbs = pathSegments.map((segment, index) => {
    currentPath += `/${segment}`;
    const isLast = index === pathSegments.length - 1;

    return (
      <span key={currentPath}>
        {isLast ? (
          <span>{segment.charAt(0).toUpperCase() + segment.slice(1)}</span>
        ) : (
          <>
            <Link to={currentPath}>{segment}</Link>
            <span> / </span>
          </>
        )}
      </span>
    );
  });

  const { cart, updateQuantity, removeFromCart } = useContext(CartContext);
  const { setEmptyCart } = useContext(EmptyCartContext);

  console.log("Cart contents:", cart);

  // Simple total without discounts
  const totalCost = cart.reduce((acc, product) => {
    const price = product.price || 0;
    const quantity = product.quantity || 1;
    return acc + price * quantity;
  }, 0);

  const totalQty = cart.reduce(
    (acc, product) => acc + (product.quantity || 1),
    0
  );

  console.log("Total:", totalCost);
  console.log("Total Qty:", totalQty);

  const showEmptyCart = () => {
    if (cart.length <= 1) {
      setEmptyCart(true);
    }
  };

  return (
    <section className={cartStyles.cartcontainer}>
      <Container fluid className="py-4">
        <Row>
          {emptyCart && cart.length === 0 && (
            <Col lg={12}>
              <div
                className={`${cartStyles.emptycartcontainer} text-center position relative`}
              >
                <div className="position-absolute top-50 start-50 translate-middle">
                  <TbShoppingCartX size={50} color="#000" className="mb-2" />
                  <p>Your shopping cart is empty</p>
                  <Link to="/shop">
                    <button className={cartStyles.shopbtn}>Shop</button>
                  </Link>
                </div>
              </div>
            </Col>
          )}
          {cart && cart.length > 0 && (
            <Col lg={12} className="border-top border-tertiary py-lg-4 py-3">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb" style={{ fontSize: "14px" }}>
                  <li className="breadcrumb-item me-2">
                    <Link to="/" className="text-decoration-none text-muted">
                      Home
                    </Link>
                  </li>
                  <span className="me-2">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.53073 2.46937L11.5307 7.46937C11.6007 7.53905 11.6561 7.62184 11.694 7.71301C11.7318 7.80417 11.7513 7.90191 11.7513 8.00062C11.7513 8.09933 11.7318 8.19707 11.694 8.28824C11.6561 8.3794 11.6007 8.46219 11.5307 8.53187L6.53073 13.5319C6.38984 13.6728 6.19874 13.7519 5.99948 13.7519C5.80023 13.7519 5.60913 13.6728 5.46823 13.5319C5.32734 13.391 5.24818 13.1999 5.24818 13.0006C5.24818 12.8014 5.32734 12.6103 5.46823 12.4694L9.93761 8L5.46761 3.53062C5.32671 3.38973 5.24756 3.19863 5.24756 2.99937C5.24756 2.80011 5.32671 2.60902 5.46761 2.46812C5.60851 2.32723 5.7996 2.24807 5.99886 2.24807C6.19812 2.24807 6.38921 2.32723 6.53011 2.46812L6.53073 2.46937Z"
                        fill="black"
                        fillOpacity="0.6"
                      />
                    </svg>
                  </span>
                  {crumbs}
                </ol>
              </nav>
            </Col>
          )}
          {cart && cart.length > 0 && (
            <div className="mb-3">
              <h2 className={`${cartStyles.carttitle} text-uppercase`}>
                Your cart
              </h2>
            </div>
          )}
          {cart && cart.length > 0 && (
            <Col lg={7} className="mb-lg-0 mb-3">
              <Card className="rounded-4 border border-tertiary">
                <Card.Body>
                  {cart.map((product) => (
                    <div key={product._id}>
                      <div
                        className={`d-flex justify-content-between ${
                          cart.length > 1
                            ? "border-bottom border-tertiary mb-3 pb-3"
                            : ""
                        }`}
                      >
                        <div className="d-flex">
                          <Image
                            src={
                              product.image ||
                              product.image_link ||
                              "https://via.placeholder.com/300"
                            }
                            fluid
                            className={`${cartStyles.productimg} rounded-4 me-3`}
                          />
                          <div>
                            <h2
                              className={`${cartStyles.producttitle} fw-semibold text-capitalize mb-5`}
                            >
                              {product.title ||
                                product.Title ||
                                "Unknown Product"}
                            </h2>
                            <div className="pt-2">
                              <h2
                                className={`${cartStyles.sliderprice} me-2 fw-semibold`}
                              >
                                ${(product.price || 0).toFixed(2)}
                              </h2>
                            </div>
                            {(product.selectedColor ||
                              product.selectedSize) && (
                              <div className="small text-muted mb-2">
                                {product.selectedColor && (
                                  <span>Color: {product.selectedColor}</span>
                                )}
                                {product.selectedColor &&
                                  product.selectedSize && <span> | </span>}
                                {product.selectedSize && (
                                  <span>Size: {product.selectedSize}</span>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="text-end">
                          <button
                            className="border-0 mb-5 bg-transparent"
                            onClick={() => {
                              removeFromCart(product._id);
                              showEmptyCart();
                            }}
                          >
                            🗑
                          </button>
                          <button className={cartStyles.qtybtn}>
                            <svg
                              onClick={() =>
                                updateQuantity(
                                  product._id,
                                  Math.max(1, (product.quantity || 1) - 1)
                                )
                              }
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.8125 10C17.8125 10.2486 17.7137 10.4871 17.5379 10.6629C17.3621 10.8387 17.1236 10.9375 16.875 10.9375H3.125C2.87636 10.9375 2.6379 10.8387 2.46209 10.6629C2.28627 10.4871 2.1875 10.2486 2.1875 10C2.1875 9.75136 2.28627 9.5129 2.46209 9.33709C2.6379 9.16127 2.87636 9.0625 3.125 9.0625H16.875C17.1236 9.0625 17.3621 9.16127 17.5379 9.33709C17.7137 9.5129 17.8125 9.75136 17.8125 10Z"
                                fill="black"
                              />
                            </svg>
                            <span className="mx-2">
                              {product.quantity || 1}
                            </span>
                            <svg
                              onClick={() =>
                                updateQuantity(
                                  product._id,
                                  (product.quantity || 1) + 1
                                )
                              }
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.8125 10C17.8125 10.2486 17.7137 10.4871 17.5379 10.6629C17.3621 10.8387 17.1236 10.9375 16.875 10.9375H10.9375V16.875C10.9375 17.1236 10.8387 17.3621 10.6629 17.5379C10.4871 17.7137 10.2486 17.8125 10 17.8125C9.75136 17.8125 9.5129 17.7137 9.33709 17.5379C9.16127 17.3621 9.0625 17.1236 9.0625 16.875V10.9375H3.125C2.87636 10.9375 2.6379 10.8387 2.46209 10.6629C2.28627 10.4871 2.1875 10.2486 2.1875 10C2.1875 9.75136 2.28627 9.5129 2.46209 9.33709C2.6379 9.16127 2.87636 9.0625 3.125 9.0625H9.0625V3.125C9.0625 2.87636 9.16127 2.6379 9.33709 2.46209C9.5129 2.28627 9.75136 2.1875 10 2.1875C10.2486 2.1875 10.4871 2.28627 10.6629 2.46209C10.8387 2.6379 10.9375 2.87636 10.9375 3.125V9.0625H16.875C17.1236 9.0625 17.3621 9.16127 17.5379 9.33709C17.7137 9.5129 17.8125 9.75136 17.8125 10Z"
                                fill="black"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </Card.Body>
              </Card>
            </Col>
          )}
          {cart && cart.length > 0 && (
            <Col lg={5}>
              <Card className="rounded-4 border border-tertiary">
                <Card.Body>
                  <div className="mb-3">
                    <h3 className="fw-semibold">Order Summary</h3>
                  </div>
                  <div className="d-flex justify-content-between pb-3 border-bottom border-tertiary">
                    <span className={`${cartStyles.carttext} d-block`}>
                      Subtotal
                    </span>
                    <span className={`${cartStyles.cartnumbertext} d-block`}>
                      ${totalCost.toFixed(2)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between pb-3 border-bottom border-tertiary">
                    <span className={`${cartStyles.carttext} d-block`}>
                      Delivery Fee
                    </span>
                    <span className={`${cartStyles.cartnumbertext} d-block`}>
                      $ 4
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center py-3">
                    <span
                      className={`${cartStyles.cartnumbertext} d-block fw-normal`}
                    >
                      Total
                    </span>
                    <span className={`${cartStyles.carttotaltext} d-block`}>
                      ${(totalCost + 4).toFixed(2)}
                    </span>
                  </div>
                  <div>
                    <Link to="/checkout">
                      <Button
                        variant="dark"
                        className={`${cartStyles.checkoutbtn} d-block w-100`}
                      >
                        Go to Checkout
                      </Button>
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>
      </Container>
    </section>
  );
};

export default Cart;
